module.exports = __webpack_public_path__ + "7e2e9f9b1364faf74fa655f9ac322435.svg";